export const getCurrency = (state) => ({ currency: state.currency.currency });
export const getCurrencyExchange = (state) => ({ exchangeRates: state.currency.exchangeRates });
export const getAvailableCurrencies = () => ['USD', 'EUR', 'CAD', 'BTC'];
export const getDefaultCurrency = () => (getAvailableCurrencies())[0];
